import { render } from "./VideoList.vue?vue&type=template&id=ce3b9a8a&scoped=true&ts=true"
import script from "./VideoList.vue?vue&type=script&lang=ts"
export * from "./VideoList.vue?vue&type=script&lang=ts"

import "./VideoList.vue?vue&type=style&index=0&id=ce3b9a8a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src129899678/src/web-ext-ai-voucher-humelo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3b9a8a"]])

export default __exports__